import axios from "axios";

/**
 * 뉴스 클릭 처리 공통 함수
 * @param {string} url - 뉴스 URL
 * @param {string} username - 유저 ID
 * @param {function} navigate - react-router-dom navigate 함수
 */
export const handleNewsClickUtil = async (url, username, navigate) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_SPRING_API_URL}/api/analyze-async`,
      {
        url,
        id: username,
      },
    );

    const createdAt = new Date(res.data.createdAt);
    const now = new Date();
    const diffHours = (now - createdAt) / (1000 * 60 * 60);

    if (diffHours >= 24) {
      console.log("24시간 이상 차이: newsprediction으로 이동");
      navigate("/newsprediction", { state: { url, id: username } });
    } else {
      console.log("24시간 미만: news로 이동");
      navigate("/news", { state: { url, id: username } });
    }
  } catch (err) {
    console.error("뉴스 데이터 가져오기 실패:", err);
  }
};
